import React from 'react'
import { Button } from '@mantine/core'
import { IconHistory } from '@tabler/icons-react'

interface EnhancedHistoryButtonProps {
  onClick: () => void
}

const EnhancedHistoryButton: React.FC<EnhancedHistoryButtonProps> = ({ onClick }) => {
  return (
    <div className="relative">
      <Button
        onClick={onClick}
        size="md"
        rightSection={<IconHistory size={18} />}
        styles={{
          root: {
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            border: 'none',
            borderRadius: '12px',
            marginRight: '-12px',
            boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0 6px 20px rgba(16, 185, 129, 0.6)',
            },
          },
        }}
        className="relative z-10"
      >
        <span className="font-semibold text-sm">查看报告</span>
      </Button>
      <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold animate-bounce z-20">
        支付后
      </div>
    </div>
  )
}

export default EnhancedHistoryButton
